<template>
    <div class="main-content">
        <div class="home-content-header">
            <h1 class="caption-title" id="v-step-0" v-if="this.$store.state.PaymentPortal_linked">Welcome, {{this.$store.state.PaymentPortal_CustomerObject.first_name}}</h1>
            <h1 class="caption-title" id="v-step-0" v-else>Welcome</h1>

            <span class="filler"> </span>
            <div class="notifications" @click="toggleToPayment()">
                 <!-- <span class="item_detail state trial" v-if="this.$store.state.PaymentPortal_SubscriptionObject.in_trial">In trial </span>
                <span class="item_detail state" v-else-if="this.$store.state.PaymentPortal_SubscriptionObject.state === 'active'">Active</span>
                <span class="item_detail state expired" v-else-if="this.$store.state.PaymentPortal_SubscriptionObject.state === 'expired'">Expired</span>
                <span class="item_detail" v-else> {{this.$store.state.PaymentPortal_SubscriptionObject.state}}</span> -->
                <!-- <b-tag type="is-success"  id="v-step-0-1" rounded closable>Notifications</b-tag> -->
                <!-- <b-tag type="is-primary" class="left-margin" rounded closable>Coming Soon</b-tag> -->
                <!-- <b-tag type="is-primary" class="left-margin" rounded>in trial</b-tag> -->
                
                <b-tag type="is-primary" class="left-margin" rounded @click="toggleToPayment()" v-if="this.$store.state.PaymentPortal_linked && this.$store.state.PaymentPortal_SubscriptionObject.in_trial">{{getplan()}} : In trial </b-tag>
                <b-tag type="is-success" class="left-margin" rounded @click="toggleToPayment()" v-else-if="this.$store.state.PaymentPortal_linked && this.$store.state.PaymentPortal_SubscriptionObject.state === 'active'">{{getplan()}} : Active</b-tag>
                <b-tag type="is-danger" class="left-margin" rounded @click="toggleToPayment()" v-else-if="this.$store.state.PaymentPortal_linked &&this.$store.state.PaymentPortal_SubscriptionObject.state === 'expired'">{{getplan()}} : Expired</b-tag>
                <b-tag type="is-primary" class="left-margin" rounded @click="toggleToPayment()" v-else-if="this.$store.state.PaymentPortal_linked"> {{this.$store.state.PaymentPortal_SubscriptionObject.state}}</b-tag>
                <!-- <b-tag type="is-primary" class="left-margin" rounded @click="toggleToPayment()" v-else>nothing</b-tag> -->
            </div>
        </div>
        <div class="home-content-models" >
            <b-tabs :value="selectTab" position="is-centered" @input="tabChanged( $event)">
                <b-tab-item>
                    <template slot="header">
                        <b-icon icon="printer-3d"></b-icon>
                        <span id="v-step-0-2"> Models </span>
                    </template>
                    <home-model-content/>
                </b-tab-item>
                <b-tab-item>
                    <template slot="header">
                        <b-icon icon="cloud-upload"></b-icon>
                        <span id="v-step-0-3"> Upload </span>
                    </template>
                    <home-model-upload/>
                </b-tab-item>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    import HomeModelContent from "@/components/Home/HomeModelContent.vue";
    import HomeModelUpload from "@/components/Home/HomeModelUpload.vue";
    export default {
        name: "HomeContent",
        data() {
            return {
            }
        },
        components: {
            HomeModelContent,
            HomeModelUpload
        },
        computed: {
            selectTab(){
                return this.$store.getters.getUploadPage;
            }
        },
        mounted: function () {
            this.getPaymentPortalData()
        },
        methods:{
            tabChanged(event){
                console.log("I am changed!",event);
                this.$store.dispatch('setCurrentTab', event)
            },
            toggleToPayment() {
                console.log("Plan trigger");
                this.$router.push('Profile');
            },
            getPaymentPortalData(){
                console.log("tried");
                if(!this.$store.state.PaymentPortal_linked){
                    console.log("inside");
                    this.$store.dispatch('PaymentPortal_get_customer_list')
                    .then(() => { 
                            console.log("Payment Portal Linked");})
                    .catch(() => {

                        console.log("Payment Portal NOTLinked");
                    })
                }
            },
            getplan(){
                if(this.$store.state.PaymentPortal_SubscriptionObject.plan === 'plan-e7a0e'){
                    return "PRO Plan";
                }
                else if(this.$store.state.PaymentPortal_SubscriptionObject.plan === 'plan-sme-monthly'){
                    return "SME Plan";
                }
                else if(this.$store.state.PaymentPortal_SubscriptionObject.plan === 'plan-enterprise-monthly'){
                    return "Enterprise Plan";
                }
                else if(this.$store.state.PaymentPortal_SubscriptionObject.plan === 'plan-min'){
                    return "Test Plan";
                }
            },

            routeToprofile(){
            }
        }
    };
</script>

<style lang="scss" scoped>

    @import "@/assets/css/colors.scss";

    %top-padding-width-height {
        width: 100%;
        height: 100%;
        top: 0;
    }
    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .main-content {
        grid-area: home-content;
        background-color: $bg-color;
        @extend %top-padding-width-height;
        display: grid;
        grid-template-areas: "home-content-header" "home-content-models";
        grid-template-rows: 10%  90%;
        grid-template-columns: 1fr;
        overflow: hidden;
    }

    .home-content-header{
        @extend %flex-center-content;
        flex-direction: row;

        h1{
            text-align: left;
            font-family: 'Roboto Slab', sans-serif;
            font-size: 200%;
            font-weight: bold;
            color: $primary-color;
        }

        span{
            flex: 1;
        }
        .notifications{
            @extend %flex-center-content;
            flex-direction: row;
            padding-right: 2%;
            *{
                margin-left: 2%;
            }
            
            span{
                padding: 18px;
                font-size: 14px;
            }

        }
    }

    .left-margin{
        /*margin-left: 2%;*/
        cursor: pointer;
    }


</style>
